import { render, staticRenderFns } from "./SetupFeeds.vue?vue&type=template&id=db2d36dc&scoped=true"
import script from "./SetupFeeds.vue?vue&type=script&lang=js"
export * from "./SetupFeeds.vue?vue&type=script&lang=js"
import style0 from "./SetupFeeds.vue?vue&type=style&index=0&id=db2d36dc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2d36dc",
  null
  
)

export default component.exports